import { Injectable, inject } from '@angular/core';
import { EnrollhereApiService } from '../enrollhere-api/enrollhere-api';
import type { ChannelDncChannel } from '../utils/channel-dnc-list';

export interface ChannelConsentUpdateRequest {
  channel: ChannelDncChannel;
  optedOut: boolean;
  note: string;
  conversationId?: string;
  conversationAccountId?: string;
}

export interface ChannelConsentUpdateResponse {
  changed: boolean;
  eventId: string;
  warning?: string;
}

@Injectable({ providedIn: 'root' })
export class ChannelConsentApiService {
  private readonly api = inject(EnrollhereApiService);

  updateChannelConsent(
    agencyId: string,
    leadId: string,
    body: ChannelConsentUpdateRequest
  ): Promise<ChannelConsentUpdateResponse> {
    return this.api.patch<ChannelConsentUpdateResponse>(
      `dialer/agency/${encodeURIComponent(agencyId)}/lead/${encodeURIComponent(leadId)}/channel-consent`,
      body
    );
  }
}
